<template>
  <div>
    <q-banner class="bg-primary text-white">
      داشبورد سی روزه
    </q-banner>
    <q-card flat>
      <q-card-section class="no-padding">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <q-select
                :dense="$q.screen.lt.md"
                class="q-ma-xs"
                filled
                v-model="userSelected"
                use-input
                input-debounce="0"
                label="اخذ گزارش بر اساس شخص"
                :options="optionsUsersList"
                @filter="filterFn"
                behavior="dialog"
                option-label="UserName"
                option-value="Users_UD"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    بدون نتیجه
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:append>
                <q-btn icon="search" flat @click="loadDashboard"/>
                <q-btn icon="cancel" flat @click="generateDashboard(undefined);userSelected=''"/>
              </template>
            </q-select>
          </div>
        </div>
      </q-card-section>
      <q-card-section class="no-padding">
        <div class="row full-width justify-center">
          <div dir="ltr" class="col-xs-12 col-md-6">
            <apexchart :options="orderChartOptions" :series="orderChartSeries"></apexchart>
          </div>
          <div dir="ltr" class="col-xs-12 col-md-6">
            <apexchart :options="factorChartOptions" :series="factorChartSeries"></apexchart>
          </div>
        </div>
      </q-card-section>
      <q-card-section class="no-padding">
        <div class="row full-width justify-center">
          <div dir="ltr" class="col-xs-12 col-md-6">
            <apexchart :options="exitChartOptions.orderChartOptions"
                       :series="exitChartOptions.orderChartSeries"></apexchart>
          </div>
          <div dir="ltr" class="col-xs-12 col-md-6">
            <apexchart :options="saleChartOptions.orderChartOptions"
                       :series="saleChartOptions.orderChartSeries"></apexchart>
          </div>
        </div>
      </q-card-section>
      <q-card-section class="no-padding">
        <div class="row">
          <div dir="ltr" class="col-xs-12 col-md-4">
            <apexchart type="pie" :options="CustomerCommentChartOptions"
                       :series="CustomerCommentChartOptions.series"></apexchart>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "SaleDashboard",
  components: {},
  data() {
    return {
      lastOrderList: [],
      lastFactorList: [],
      lastExiList: [],
      lastSaleList: [],
      userSelected: '',
      usersList: [],
      optionsUsersList: [],
      orderChartOptions: {
        chart: {
          id: 'vuechart-example',
          type: 'area',
          toolbar: {
            show: false
          }
        },
        title: {
          text: 'تعداد کالا سفارش داده شده در سی روز اخیر',
          align: 'center',
          floating: false,
          style: {
            fontFamily: 'IRANSans, sans-serif'
          }
        },
        xaxis: {
          labels: {
            hideOverlappingLabels: true,
            rotate: -45
          },
          categories: []
        },
      },
      orderChartSeries: [{
        name: 'تعداد کالا',
        data: []
      }],
      factorChartOptions: {
        chart: {
          id: 'vuechart-example',
          type: 'area',
          toolbar: {
            show: false
          }
        },
        colors: ['purple'],
        title: {
          text: 'تعداد کالای فاکتور شده در سی روز اخیر',
          align: 'center',
          floating: false,
          style: {
            fontFamily: 'IRANSans'
          }
        },
        xaxis: {
          labels: {
            rotate: -45
          },
          categories: []
        }
      },
      factorChartSeries: [{
        name: 'تعداد کالا',
        data: []
      }],

      exitChartOptions: {
        orderChartOptions: {
          chart: {
            id: 'vuechart-example',
            type: 'area',
            toolbar: {
              show: false
            }
          },
          colors: ['green'],
          title: {
            text: 'تعداد کالای حواله شده سی روز اخیر',
            align: 'center',
            floating: false,
            style: {
              fontFamily: 'IRANSans'
            }
          },
          xaxis: {
            labels: {
              hideOverlappingLabels: true,
            },
            categories: []
          },
        },
        orderChartSeries: [{
          name: 'تعداد کالا',
          data: []
        }],
      },
      saleChartOptions: {
        orderChartOptions: {
          chart: {
            id: 'vuechart-example',
            type: 'area',
            toolbar: {
              show: false
            }
          },
          colors: ['blue'],
          title: {
            text: 'فروش  سی روز اخیر',
            align: 'center',
            floating: false,
            style: {
              fontFamily: 'IRANSans, sans-serif'
            }
          },
          xaxis: {
            labels: {
              hideOverlappingLabels: true,
            },
            categories: [],
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return val.toLocaleString();
              }
            }
          },
          dataLabels: {
            formatter: function (val) {
              return val.toLocaleString();
            }
          }
        },
        orderChartSeries: [{
          name: 'مبلغ ',
          data: [],
        }],
      },
      CustomerCommentChartOptions: {
        series: [],
        chartOptions: {
          chart: {
            type: 'pie',
            fontFamily: 'IRANSans, sans-serif'
          },
          labels: [],
          legend: {
            position: "bottom",
            height: 90,
            offsetY: -20,
            style: {
              fontFamily: 'IRANSans, sans-serif'
            }
          }
        }
      }
    }
  },
  methods: {
    ...mapActions({
      GetDashboardData: 'Dashboard/getData'
    }),
    filterFn(val, update) {
      if (val === '') {
        update(() => {
          this.optionsUsersList = this.usersList
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.optionsUsersList = this.usersList.filter(v => v.UserName.toLowerCase().indexOf(needle) > -1)
      })
    },
    loadDashboard() {
      if (this.userSelected) {
        this.generateDashboard(this.userSelected.Users_ID)
      }
    },
    generateDashboard(user_id) {
      let today = new Date()
      let EndDate = this.ToJalaliDateTime(today).split(' ')[0].replaceAll('/', '-')
      let StartDate = this.ToJalaliDateTimeByDayDiff(today, 30).split(' ')[0].replaceAll('/', '-')

      this.GetDashboardData({
        startDate: StartDate,
        endDate: EndDate,
        enStartDate: this.getTodayDateTimeByDiff(30),
        enEndDate: this.getTodayDateTime(),
        userid: user_id === undefined ? '' : user_id
      }).then((res) => {
        this.lastOrderList = JSON.parse(res.last_orders);
        this.lastFactorList = JSON.parse(res.last_factor);
        this.usersList = JSON.parse(res.users_list)
        this.optionsUsersList = this.usersList
        this.orderChartOptions = {
          xaxis: {
            categories: this.lastOrderList.map(item => item.Sale_Date)
          }
        }
        this.orderChartSeries = [{
          data: this.lastOrderList.map(item => item.Co)
        }]

        this.factorChartOptions = {
          xaxis: {
            categories: this.lastFactorList.map(item => item.Sale_Date)
          }
        }
        this.factorChartSeries = [{
          data: this.lastFactorList.map(item => item.Co)
        }]

        this.lastExiList = JSON.parse(res.last_exit);
        this.exitChartOptions.orderChartOptions = {
          xaxis: {
            categories: this.lastExiList.map(item => item.Sale_Date)
          }
        }
        this.exitChartOptions.orderChartSeries = [{
          data: this.lastExiList.map(item => item.Co)
        }]

        this.lastSaleList = JSON.parse(res.fac_list_by_day);
        this.saleChartOptions.orderChartOptions = {
          xaxis: {
            categories: this.lastSaleList.map(item => item.Sale_Date)
          }
        }
        this.saleChartOptions.orderChartSeries = [{
          data: this.lastSaleList.map(item => item.Sale_Pay)
        }]
        this.CustomerCommentChartOptions = {
          series: [JSON.parse(res.customer_comment)[0].CustomerCo, JSON.parse(res.customer_comment)[0].CustomerVisitLogCo],
          labels: ['تعداد طرف معامله ثبت شده', 'تعداد یادداشت های ثبت شده']
        }
      })
    }
  },
  watch: {
    userSelected: function (val) {
      if (val === null) {
        this.userSelected=''
        this.generateDashboard(undefined)
      }
    }
  },
  created() {
    this.generateDashboard(undefined)
  }
}
</script>

<style scoped>
</style>
